import { render, staticRenderFns } from "./ResumeReview.vue?vue&type=template&id=161ed3b8&scoped=true"
import script from "./ResumeReview.vue?vue&type=script&lang=js"
export * from "./ResumeReview.vue?vue&type=script&lang=js"
import style0 from "./ResumeReview.vue?vue&type=style&index=0&id=161ed3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ed3b8",
  null
  
)

export default component.exports